export const getShoppingStep = (state) => state?.shoppingStep //return current shopping step (global state)

export const getContratStep = (state) => state?.contratStep //return current shopping step (global state)

export const getIdSpot = (state) => state?.idSpot //return id of selected spot (global state)

export const getIdSpotLoc = (state) => state?.idSpotLoc //return id of selected spot (global state)

export const getRidingPeriod = (state) => [state?.dates,state?.heures]; //return start and return dates + start and return hours (2 arrays in 1 array) (global state)

export const getDuree = (state) => state?.duree; //return object with qty of half-day, days, wekks...

export const getLivraison = (state) => state?.livraison; //return object with valid, secteur, adresse, comp...

export const getPanier = (state) => state?.panier; //return object with all articles in panier

export const getUserData = (state) => state?.userData; //return object with all user infos

export const getCommentaire = (state) => state?.commentaire; //return commentaire

export const getContrat = (state) => state?.contrat; //return comntrat

export const getShowPanier = (state) => state?.showPanier; //return show Panier

export const getStockArticles = (state) => state?.stockArticles; //return list of stock Articles

export const getSpotsList = (state) => state?.spotsList; //return list of spots

export const getAccess = (state) => state?.accessoires; //return list of spots

export const getCGV = (state) => state?.checkCGV; //return list of spots

export const getLang = (state) => state?.lang; //return selected language